import { render } from "./PharmacoGenomics.vue?vue&type=template&id=2ccb804b"
import script from "./PharmacoGenomics.vue?vue&type=script&lang=js"
export * from "./PharmacoGenomics.vue?vue&type=script&lang=js"

import "./PharmacoGenomics.vue?vue&type=style&index=0&id=2ccb804b&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__